/**
 * Admin — Evaluations Routes
 *
 * Routes:
 * - /admin/evaluations                    → 'admin-evaluations'
 * - /admin/evaluations/new               → 'admin-evaluation-form'
 * - /admin/evaluations/:evaluationId/edit → 'admin-evaluation-form'
 */

import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminEvaluationsRoutes: RouteObject[] = [
  {
    path: 'admin/evaluations',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_EVALUATIONS, title: 'Évaluations' },
  },
  {
    path: 'admin/evaluations/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_EVALUATION_FORM, title: 'Nouvelle évaluation' },
  },
  {
    path: 'admin/evaluations/:evaluationId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_EVALUATION_FORM, title: "Modifier l'évaluation" },
  },
];
